import { action } from 'satcheljs';
import TimeProfileShownView from '../store/schema/TimeProfileShownView';

/**
 * Action to update the shown view in the store.
 */
let setShownView = action(
    'SET_AVAILABILITY_PROFILE_SHOWN_VIEW',
    (shownView: TimeProfileShownView) => ({
        shownView,
    })
);

export default setShownView;
